export const languageElements = {
  items: {
    "link-details": {
      hu: "Részletek...",
      de: "Weiterlesen...",
      en: "Details...",
    },
    "news-greeting-title": {
      hu: "Üdvözöljük!",
      de: "Willkommen!",
      en: "Welcome!",
    },
    "news-greeting-p01": {
      hu: "Köszönjük, hogy használja Customer Portal-unkat.",
      de: "Vielen Dank, dass Sie unser Kundenportal nutzen.",
      en: "Thank you for using our Customer Portal.",
    },
    "news-greeting-p02": {
      hu: "Jelenleg nem találhatók különleges tájékoztató információk a rendszerben.",
      de: "Derzeit sind keine besonderen Informationen im System vorhanden.",
      en: "There is currently no special information in the system.",
    },
  },
};
